import Notifications from 'react-notification-system-redux';

// actions
export const notifySuccess = (message) => {
	return (dispatch, getState) => {
		const data = {
			title: 'Success',
			message: message
		};
		dispatch(Notifications.success(data));
	}
};

export const notifyError = (message) => {
	return (dispatch, getState) => {
		const data = {
			title: 'Error',
			message: message
		};
		dispatch(Notifications.error(data));
	}
};

export const notifyShow = (notificationOpts, level) => {
	return (dispatch, getState) => {
		// const notificationOpts = {
		// 	title: 'Hey, it\'s good to see you!',
		// 	message: 'Now you can see how easy it is to use notifications in React!',
		// 	position: 'tc',
		// 	autoDismiss: 0,
		// 	action: {
		// 		label: 'Click me!!',
		// 		callback: () => alert('clicked!')
		// 	}
		// };
		// // level -> success, error, warning and info
		// const level = 'error';
		dispatch(Notifications.show(notificationOpts, level));
	}
};
